import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import { useWindowScroll, useClickAway } from 'react-use';
import { TOOLTIP_CLASS_NAME, Tooltip as Tooltip$1, TooltipStyles } from './Tooltip.styles.mjs';
"use strict";
const Tooltip = ({
  children,
  tooltipClassName,
  ...rest
}) => {
  const target = useRef(null);
  const tooltipRef = useRef(null);
  const {
    y: scrollY
  } = useWindowScroll();
  const [isOpen, setIsOpen] = useState();
  useEffect(() => {
    setIsOpen(false);
  }, [
  // HACK: needed scrollY to retrigger the effect
  scrollY]);
  useClickAway(tooltipRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });
  const classNameList = [TOOLTIP_CLASS_NAME, tooltipClassName];
  const tooltipClassNames = classNameList.join(" ");
  return /* @__PURE__ */jsx(Tooltip$1, {
    ref: tooltipRef,
    isOpen,
    ...rest,
    tooltipClassName: tooltipClassNames,
    children: /* @__PURE__ */jsxs("div", {
      ref: target,
      onMouseLeave: () => setIsOpen(false),
      onMouseEnter: () => setIsOpen(true),
      onTouchStart: () => setIsOpen(!isOpen),
      children: [/* @__PURE__ */jsx(TooltipStyles, {}), children]
    })
  });
};
export { Tooltip };
//# sourceMappingURL=Tooltip.mjs.map
